import HTTP from "@/plugins/http";
import utils from "@/resources/utils";
import validationStatusCode from "@/resources/validation_status_code";

const getUser = async (token, username) =>
  validationStatusCode(
    await HTTP.get(`/users/${username}/`, { headers: utils.headerAuth(token) })
  );

const getUsers = async (token, page, email) => {
  let endpoint = `/users/?page=${page}&pagination=true`;

  if (email) endpoint += `&email=${email}`;

  return validationStatusCode(
    await HTTP.get(endpoint, {
      headers: utils.headerAuth(token)
    })
  );
};

const createUser = async (token, user) =>
  validationStatusCode(
    await HTTP.post("/users/signup/", user, {
      headers: utils.headerAuth(token)
    })
  );

const deleteUser = async (token, username) =>
  validationStatusCode(
    await HTTP.delete(`/users/${username}/`, {
      headers: utils.headerAuth(token)
    })
  );

const updateUser = async (token, username, user) =>
  validationStatusCode(
    await HTTP.patch(`/users/${username}/`, user, {
      headers: utils.headerAuth(token)
    })
  );

const getUserWithoutPagination = async (token, vet, owner) =>
  validationStatusCode(
    await HTTP.get(`/users/without_pagination/?vet=${vet}&owner=${owner}`, {
      headers: utils.headerAuth(token)
    })
  );

const sendEmail = async (token, mail) => {
  return validationStatusCode(
    await HTTP.post("/users/send_multiple_emails", mail, {
      headers: utils.headerAuth(token)
    })
  );
};

export default {
  getUser,
  getUsers,
  sendEmail,
  createUser,
  deleteUser,
  updateUser,
  getUserWithoutPagination
};
